import CollectionPlayer from "@/employee/CollectionPlayer"
import util from "@/util"
import { list, map, primitive, serializable } from "serializr"

export default class EffectType {
  // Temporary: Effect can be removed
  // Permanent: Effect can not be removed by being "unequipped"
  // Reverting: Same as Temporary but effect will start removing itself once its duration is reached
  @serializable
  public readonly permanence: string // temporary, permanent, reverting

  // Instant: Effect is applied immediately and is removed after duration finishes
  // Slow: Effect value ramps up gradually over the duration
  @serializable
  public readonly timeType: string // instant, slow

  // How long the effect will last (depends on what other types effect is)
  @serializable
  public readonly duration: number

  constructor(duration: number = 0, timeType: string = 'instant', permanence: string = 'temporary') {
    this.duration = duration
    this.timeType = timeType
    this.permanence = permanence
  }

  equals(t: EffectType) {
    return this.duration == t.duration && this.timeType == t.timeType && this.permanence == t.permanence
  }
}
